const getters = {
    token: state => state.app.token,
    school: state => state.app.school,
    schoolItem: state => state.app.schoolItem,
    idCard: state => state.app.idCard
  };
  export default getters;